import { useQuery } from "@tanstack/react-query";

import { ListDocumentsFilterType } from "@/domain/uploadedDocuments";

import { UploadedDocumentsApi } from "../api/uploadedDocumentsApi";

export const UploadedDocumentQueryKeys = {
  all: ["documents"] as const,
  list: (filters: ListDocumentsFilterType) =>
    filters
      ? ([...UploadedDocumentQueryKeys.all, "list", filters] as const)
      : ([...UploadedDocumentQueryKeys.all, "list"] as const),
  detail: (documentId: string) =>
    [...UploadedDocumentQueryKeys.all, "detail", documentId] as const,
  categories: () => [...UploadedDocumentQueryKeys.all, "categories"] as const,
  requirements: () =>
    [...UploadedDocumentQueryKeys.all, "requirements"] as const,
};

export const useListDocumentsQuery = (filters: ListDocumentsFilterType) => {
  return useQuery({
    queryKey: UploadedDocumentQueryKeys.list(filters),
    queryFn: () => UploadedDocumentsApi.listDocuments(filters),
  });
};

export const useGetDocumentQuery = (documentId: string) => {
  return useQuery({
    queryKey: UploadedDocumentQueryKeys.detail(documentId),
    queryFn: () => UploadedDocumentsApi.getDocument(documentId),
  });
};

export const useListDocumentCategoriesQuery = () => {
  return useQuery({
    queryKey: UploadedDocumentQueryKeys.categories(),
    queryFn: () => UploadedDocumentsApi.listDocumentCategories(),
    staleTime: Infinity, // Categories are unlikely to change frequently
  });
};

export const useListDocumentRequirementsQuery = () => {
  return useQuery({
    queryKey: UploadedDocumentQueryKeys.requirements(),
    queryFn: () => UploadedDocumentsApi.listDocumentRequirements(),
  });
};
